import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 * @param cancelToken - Token to cancel multiple requests
 * @returns - Array of Terminal List of type IManifestPro
 */

export const commodityTypeMasterApi = async () => {
  try {
    const response = await axios.get(`${getUrl(ApiType.COMMODITY_TYPE_MASTER)}`);

    const commodityTypeMasterData = response?.data?.data ?? [];
    return commodityTypeMasterData;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.commodityTypeMaster, { badRequestOrder: "errorsFirst" });
  }
};
